/* DefinitionSources.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./DefinitionSources.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import Button, { IconButton } from '@atlaskit/button/new';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { SourcesStack } from '../../../../common/ui/sources-stack/sources-stack';
import { useFetchSmartlinkData } from '../../../common/hooks/use-fetch-smartlink-data';
import { DefinitionSource } from './DefinitionSource';
var messages = defineMessages({
  definition_sources_stack_text: {
    id: 'search_ai.definition_sources_stack_text',
    defaultMessage: '{numResolvedSources, plural, =1 {{numResolvedSources, number} Source} other {{numResolvedSources, number} Sources}}',
    description: 'Sources text'
  },
  definition_source_stack_text: {
    id: 'search_ai.definition_source_stack_text',
    defaultMessage: 'source',
    description: 'Source text when only one source'
  }
});
var styles = {
  root: "_ca0qu2gc _u5f3pxbi _19bvpxbi _n3tdu2gc",
  sourcesStackContainerStyles: "_2rko1qi0 _1dqonqa1 _189ee4h9 _1h6d1l7x _1bsb1ns9 _19bvutpp _u5f3utpp _ca0q12x7 _n3td12x7",
  dividerStyles: "_15a5nqa1 _uwhke4h9 _1i531l7x"
};
var DEFINITION_MAX_SOURCES = 3;
export var DefinitionSources = function DefinitionSources(_ref) {
  var sources = _ref.sources;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    sourcesExpanded = _useState2[0],
    setSourcesExpanded = _useState2[1];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var sourcesUrls = sources.map(function (source) {
    return source.url;
  }).slice(0, DEFINITION_MAX_SOURCES);
  var _useFetchSmartlinkDat = useFetchSmartlinkData({
      urls: sourcesUrls
    }),
    objectResolverData = _useFetchSmartlinkDat.objectResolverData;
  var numResolvedSources = objectResolverData.length;
  return numResolvedSources === 0 ? null : /*#__PURE__*/React.createElement(Box, {
    xcss: styles.root
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.100",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setSourcesExpanded(!sourcesExpanded);
    }
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(SourcesStack, {
    maxSourcesInStack: DEFINITION_MAX_SOURCES,
    sources: sources.slice(0, numResolvedSources)
  }), /*#__PURE__*/React.createElement(Text, {
    color: "color.text.subtle"
  }, formatMessage(messages.definition_sources_stack_text, {
    numResolvedSources: numResolvedSources
  })))), /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      return setSourcesExpanded(!sourcesExpanded);
    },
    icon: function icon(iconProps) {
      return sourcesExpanded ? /*#__PURE__*/React.createElement(ChevronDownIcon, _extends({}, iconProps, {
        size: "small"
      })) : /*#__PURE__*/React.createElement(ChevronRightIcon, _extends({}, iconProps, {
        size: "small"
      }));
    },
    appearance: "subtle",
    label: sourcesExpanded ? 'Collapse sources button' : 'Expand sources button',
    testId: "definitions-sources-expand"
  })), sourcesExpanded && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.dividerStyles
  }), /*#__PURE__*/React.createElement(Stack, {
    space: "space.200"
  }, objectResolverData.map(function (sourceData, idx) {
    return /*#__PURE__*/React.createElement(DefinitionSource, {
      sourceData: sourceData,
      index: idx,
      key: "".concat(sourceData.data.url, "-").concat(idx)
    });
  })))));
};